// extracted by mini-css-extract-plugin
export default {"quizTimeText":"root_quiz-content-module__quizTimeText___Jbn4u","text":"root_quiz-content-module__text___tfkdd"};